const DOCUMENT_CONSENT = 'documentConsent'

class AppController {
  constructor (Localization, StoreTypes, CookiesService, $scope, $window, $rootScope) {
    'ngInject'
    this.type = Localization.getLocalizedAppConfig().type
    this.StoreTypes = StoreTypes
    this.$window = $window

    $rootScope.$on('cookieConsentUpdated', () => {
      this.updateCaptchaConsent(CookiesService.consentForCookie('captcha'))
    })

    $scope.$on('globalSpinner:on', (event, data) => {
      this.isProcessing = true
    })

    $scope.$on('globalSpinner:off', (event, data) => {
      this.isProcessing = false
    })

    $scope.$on('checkDocumentConsent:on', (event, data) => {
      try {
        if (this.$window.localStorage) {
          this.$window.localStorage[DOCUMENT_CONSENT] = true
        }
      } catch (e) {
        console.error('Error when processing document consent activation')
      }
    })

    $scope.$on('checkDocumentConsent:off', (event, data) => {
      try {
        if (this.$window.localStorage) {
          this.$window.localStorage[DOCUMENT_CONSENT] = false
        }
      } catch (e) {
        console.error('Error when processing document consent activation')
      }
    })
  }

  get isIframe () {
    return (this.type === this.StoreTypes.HELIOS ||
      this.type === this.StoreTypes.MYRENAULT ||
      this.type === this.StoreTypes.RSITE ||
      this.type === this.StoreTypes.ONE)
  }

  get showHeader () {
    return (this.type === this.StoreTypes.STANDALONE || this.type === this.StoreTypes.RSITE)
  }

  get showFooter () {
    return this.type === this.StoreTypes.STANDALONE
  }

  get showCookiesConsent () {
    return this.type === this.StoreTypes.STANDALONE
  }

  get showDocumentConsent () {
    return this.$window.localStorage && (this.$window.localStorage[DOCUMENT_CONSENT] === 'true')
  }

  updateCaptchaConsent (consentValue) {
    let scriptElement = document.getElementById('captchaScript')
    if (!scriptElement && consentValue) {
      // <script src="https://cdn.polyfill.io/v2/polyfill.js"></script>
      const loadRecaptcha = () => this.loadScript('https://www.google.com/recaptcha/api.js?onload=vcRecaptchaApiLoaded&render=explicit', el => {
        el.async = true
        el.defer = true
        el.id = 'polyfill'
      }).then(() => {
        console.log('Scripts loaded')
      })

      if (!document.getElementById('polyfill')) {
        this.loadScript('https://cdn.polyfill.io/v2/polyfill.js', el => {
          el.id = 'polyfill'
        }).then(() => loadRecaptcha())
      } else {
        loadRecaptcha()
      }
    } else if (!consentValue && scriptElement) {
      scriptElement.parentElement.removeChild(scriptElement)
    }
  }

  loadScript (url, editor = el => {}) {
    return new Promise((resolve, reject) => {
      const script = document.createElement('script')
      script.src = url
      editor(script)
      script.onload = resolve
      script.onerror = e => reject(Error(`${url} failed to load`))
      document.head.appendChild(script)
    })
  }
}

export default AppController



// WEBPACK FOOTER //
// ./src/app/app.controller.js